import React from 'react';
import { useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Container, Row, Col, Form } from 'react-bootstrap';
import { BsArrowUpRight } from "react-icons/bs";
import ContactNowPopup from './ContactNowPopup';

function Currentposition() {
        const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    return (
        <section className='current-position'>
            <div className='container'>
                <div className='row align-items-center'>
                    <div className='col-xlg-8 col-lg-8'>
                        <div className='current-position'>
                            <h2>Current positions</h2>
                            <p>As Senior Physician at <strong> Maya Nursing Home</strong>, I specialize in the care of geriatric patients, managing their complex health needs through comprehensive treatments, counseling, and regular follow-ups. I oversee the OP Department, ensuring personalized care for elderly patients, and provide cross-consultations and expert opinions on age-related health concerns.</p>
                            <p className='mb-4'>I conduct pre-operative fitness assessments and risk stratification for surgical patients, with a focus on geriatric care. I also maintain strong relationships with all departments to ensure seamless coordination and quality care for elderly patients, while conducting master health check-ups focused on preventing age-related health issues.</p>
                        <Button className='about-contact-btn' variant="primary" onClick={handleShow} style={{background:'#fff', color:'#0eb5cd', border:'none'}}>Contact Now</Button>

                        <Modal show={show} onHide={handleClose} backdrop="static" keyboard={false} size="lg">
                            <Modal.Body>
                                <section className="py-5 bodyofcontactform">
                                    {/* <div style={{ position: 'absolute', top: '20px', right: '20px' }}>
                                        <img src="assets/images/footer-logo.png" alt="Dr. Mahadevan" style={{ width: '80px', height: '80px', borderRadius: '50%' }} />
                                    </div> */}

                                    <Container>
                                        <Row>
                                            <Col className='conact-form-heading' md={12}>
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <h2 className='contact-now-form-title' >Let's talk</h2>
                                                    <Button 
                                                        onClick={handleClose}
                                                        className="close-button"
                                                        variant="link"
                                                        style={{
                                                            fontSize: '40px',
                                                            color: '#000',
                                                            textDecoration: 'none',
                                                            padding: '0 8px',
                                                            position: 'relative',
                                                            right: '0%',
                                                            bottom: '60px'
                                                        }}
                                                    >
                                                        ×
                                                    </Button>
                                                </div>
                                                <p className='about-conact-details' style={{ fontWeight: '600', fontSize: '18px' }}>
                                                    Contact Number: <a href="tel:+919940451580">+91 9940451580</a><br />
                                                    Email: <a href="mailto:drgrmaha@gmail.com">drgrmaha@gmail.com</a>
                                                </p>
                                            </Col>
                                        </Row>

                                        <ContactNowPopup/>

                                       
                                    </Container>
                                </section>
                            </Modal.Body>
                        </Modal>
                        </div>
                    </div>
                    <div className='col-xlg-4 col-lg-4'>
                        <div className='current-position-img'>
                            <img src="assets/images/current-positions-img.png" alt="Dr. Mahadevan Logo" />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Currentposition;
